class ProductButtons extends HTMLElement {
  static classes = {
    fixed: 'fixed',
    static: 'static',
  };
  static ISFIXED = 1;
  static ISSTATIC = 0;
  status; initialScrollTop; 

  constructor() {
    super();
    this.init();
  }
  
  init = () => {
    this.initialScrollTop = this.offsetTop;
    this.checkPosition();
    // Monitora lo scroll della pagina per aggiornare lo stato di fissaggio dei pulsanti
    window.onscroll = () => {
      this.checkPosition();
    };
  }

  checkPosition = () => {
    // Calcola la posizione di scroll in modo cross-browser
    const y = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
    
    // I pulsanti rimangono fissi finché l'utente non ha scrollato al di là della loro posizione iniziale
    if (y >= this.initialScrollTop) {
      this.setStatic();
    }
    else {
      this.setFixed();
    }
  }

  setFixed = () => {
    this.classList.add(ProductButtons.classes.fixed);
    this.status = ProductButtons.ISFIXED;
  }

  setStatic = () => {
    this.classList.remove(ProductButtons.classes.fixed);
    this.status = ProductButtons.ISSTATIC;
  }
}
if (!window.customElements.get("product-buttons")) {
  window.customElements.define("product-buttons", ProductButtons);
}

class ProductAdd extends HTMLElement {
  loader; form;
  static selectors = {
    loader: '[data-spinner]',
    price: '[data-price]'
  };
  static classes = {
    hidden: 'd-none'
  }

  constructor() {
    super();
    this.init();
  }
  
  init = () => {
    this.loader = this.querySelector(ProductAdd.selectors.loader);
    this.price = this.querySelector(ProductAdd.selectors.price);
    this.form = this.closest('form');

    this.addEventListener('click', () => this.addTocart());
    // Operabilità da tastiera: Invio/Spazio aggiungono al carrello (role="button")
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.addTocart();
      }
    });
  }

  addTocart = () => {
    if(this.form != undefined){
      Utils.addTocart({
        form: this.form,
        before: () => {
          this.showLoader();
        },
        success: (data) => {
          this.added();
        },
        finally: () => {
          this.hideLoader();
        }
      });
    }
  }

  added = () => {
    
  }

  showLoader = () => {
    if(this.loader != undefined)
      this.loader.classList.remove(ProductAdd.classes.hidden);
    if(this.price != undefined)
      this.price.classList.add(ProductAdd.classes.hidden);
  }

  hideLoader = () => {
    if(this.loader != undefined)
      this.loader.classList.add(ProductAdd.classes.hidden);
    if(this.price != undefined)
      this.price.classList.remove(ProductAdd.classes.hidden);
  }
  
}
if (!window.customElements.get("product-add")) {
  window.customElements.define("product-add", ProductAdd);
}

class MainProduct extends HTMLElement {
  loader;

  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.loader = document.querySelector('theme-loader');
  }

  update = (variant) => {
    // Ricarica il contenuto della pagina prodotto quando l'utente seleziona una variante diversa
    this.showLoader();
    const url = new URL(window.location.href);
    if(variant != undefined){
      // Aggiunge o aggiorna il parametro variant nell'URL
      url.searchParams.set('variant', variant);
    }
    else {
      // Rimuove il parametro variant se la variante è undefined
      url.searchParams.delete('variant');
    }
    axios.get(url)
      .then((response) => {
        const doc = Utils.getDocument(response.data);
        // Aggiorna solo il contenuto del main-product, preservando il resto della pagina
        this.innerHTML = doc.querySelector('main-product').innerHTML;
        // Aggiorna l'URL del browser senza ricaricare la pagina
        window.history.replaceState(null, null, url);
      })
      .catch((error) => {
        Utils.errorHanlder(error);
      })
      .finally(() => {
        this.hideLoader();
      });
  }

  showLoader = () => {
    if(this.loader != undefined)
      this.loader.show();
  }

  hideLoader = () => {
    if(this.loader != undefined)
      this.loader.hide();
  }
}
if (!window.customElements.get("main-product")) {
  window.customElements.define("main-product", MainProduct);
}

class ProductVariant extends HTMLElement {
  product;

  constructor() {
    super();
    this.init();
  }
  
  init = () => {
    this.product = document.querySelector('main-product');
    this.addEventListener('click', (e) => this.changeVariant(e));
    // Operabilità da tastiera: Invio/Spazio attivano la selezione variante (role="button")
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.changeVariant();
      }
    });
  }
  
  changeVariant = (e) => {
    if(e != undefined)
      e.preventDefault();
    if(this.product != undefined){
      this.product.update(this.dataset.variant);
    }
  }
}
if (!window.customElements.get("product-variant")) {
  window.customElements.define("product-variant", ProductVariant);
}

class ProductNotify extends HTMLElement {

  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.addEventListener('click', (e) => this.openNotify());
    // Operabilità da tastiera: Invio/Spazio aprono la notifica restock (role="button")
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.openNotify();
      }
    });
  }

  openNotify = () => {
    if(window._RestockRocket != undefined){
      window._RestockRocket.openModal();
    }
  }
}
if (!window.customElements.get("product-notify")) {
  window.customElements.define("product-notify", ProductNotify);
}

class ProductThumb extends HTMLElement {
  swipers;

  connectedCallback() {
    this.swipers = this.closest('main-product').querySelectorAll('theme-swiper');
    this.addEventListener('click', this.changeSlide.bind(this));
    // Operabilità da tastiera: Invio/Spazio avanzano la galleria (role="button")
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.changeSlide();
      }
    });
  }

  changeSlide = () => {
    this.swipers.forEach(element => {
      element.swiper.slideNext();
    });
  }
}
if (!window.customElements.get("product-thumb")) {
  window.customElements.define("product-thumb", ProductThumb);
}

class ProductTabLink extends HTMLElement {
  tabs;

  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.tabs = document.querySelectorAll(`[data-tab-btn="${this.dataset.tab}"]`);
    this.addEventListener('click', (e) => {
      this.tabs.forEach(tab => {
        this.changeTab(tab);
      });
    });
    // Operabilità da tastiera: Invio/Spazio replicano il click (apre l'offcanvas via
    // data-bs-toggle e seleziona il tab), role="button" sull'elemento
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.click();
      }
    });
  }

  changeTab = (tab) => {
    const bstab = bootstrap.Tab.getOrCreateInstance(tab);
    bstab.show();
  }
}
if (!window.customElements.get("product-tab-link")) {
  window.customElements.define("product-tab-link", ProductTabLink);
}
